import * as angular from "angular";
import * as _ from "lodash";
import { BVUtils } from "../BVUtils";

import { ModelBase, BaseModel, modelModule } from './model';

export class JobsModel extends ModelBase {

    constructor($http: ng.IHttpService, $q: ng.IQService, $log: ng.ILogService, baseModel: BaseModel) {
        super('api/Jobs/', $http, $q, $log, baseModel);
	}

	public getNotifications(pageSize?: number, offset?: number) {

		if (_.isNil(pageSize)) {
			pageSize = 5;
		}
		if (_.isNil(offset)) {
			offset = 0;
		}

		var deferred: angular.IDeferred<model.INotificationItem[]> = this.$q.defer(); 

		this.$http.get<model.INotificationItem[]>(this.GetUrl('Notifications'), {
			'params': {
				'pageSize': pageSize,
				'offset': offset
			}
		})
			.then((data) => {
				let result = data.data; 
				for (let n of result) {
					n.CreatedDate = BVUtils.GetDate(n.CreatedDate);
					n.ChangedDate = BVUtils.GetDate(n.ChangedDate); 
				}
				deferred.resolve(result); 
			})
			.catch((data) => {
				this.LogError("getNotifications",data);
				deferred.reject(data.data); 
			});

		return deferred.promise; 

	}

	public getNotificationsByID(id:string) {
		var deferred: angular.IDeferred<model.INotificationItem[]> = this.$q.defer();

		this.$http.get<model.INotificationItem[]>(this.GetUrl('NotificationsByID'), {
			'params': {
				'id': id
			}
		})
			.then((data) => {
				let result = data.data;
				for (let n of result) {
					n.CreatedDate = BVUtils.GetDate(n.CreatedDate);
					n.ChangedDate = BVUtils.GetDate(n.ChangedDate);
				}
				deferred.resolve(result);
			})
			.catch((data) => {
				this.LogError("getNotificationsByID", data);
				deferred.reject(data.data);
			});

		return deferred.promise;

	}

	public notificationViewed(groupID: string | string[]) {
		var deferred: angular.IDeferred<boolean> = this.$q.defer(); 

		if (!_.isArray(groupID)) {
			groupID = [groupID];
		}

		this.$http.post<boolean>(this.GetUrl("NotificationViewed"), groupID)
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("notificationViewed",data);
				deferred.reject(data.data);
			});

		return deferred.promise; 
	}
}

modelModule.factory('jobsModel', ['$http', '$q', '$log', 'baseModel', ($http, $q, $log, baseModel) => new JobsModel($http, $q, $log, baseModel)]);


// WEBPACK FOOTER //
// ./Common/Models/JobsModel.ts